import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChart4: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chart-4, statistics, graph"><path d="M9.25 20.25V14.75H3.75V20.25H9.25ZM9.25 20.25H14.75M9.25 20.25V9.25H14.75V20.25M14.75 20.25H20.25V3.75H14.75V20.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChart4;
